export class IConfigMask {
    mask?: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/jquery-date-picker/interfaces/config-mask.ts